export default __webpack_public_path__ + "static/media/pokedex_logo.907dcf3a.png";